import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Stack } from '@mui/material';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';

import { ListSection } from './ListSection';
import { TemplatesResponse, useBPFMutations } from '../../api';

interface Props {
  templates: TemplatesResponse['bpf']['templates'];
}

export const TemplatesList = ({ templates }: Props) => {
  const { push } = useHistory();
  const { handleSetActiveStatus, isActiveStatusSetting } = useBPFMutations();

  const handleRedirectToCreateTemplatePage = () => {
    push('/bpf/template');
  };

  const handleRedirectToDepartmentsManagementPage = () => {
    push('/bpf/departments');
  };

  const handleRedirectToCloseReasonConfigurationPage = (templateId: string) => {
    push(`/bpf/closeReasonConfiguration/${templateId}`);
  };

  const handleEditTemplate = async (templateId: string) => {
    push({ pathname: `/bpf/template/${templateId}` });
  };

  return (
    <CardContainer
      title="Deal Stages"
      actionBtn={
        <Stack direction="row" gap="1rem">
          <Button size="large" onClick={handleRedirectToDepartmentsManagementPage}>
            Update Departments
          </Button>

          <Button size="large" variant="contained" onClick={handleRedirectToCreateTemplatePage}>
            Create New template
          </Button>
        </Stack>
      }
    >
      <Stack gap="1rem">
        {templates.map(({ templates, department }, index) => (
          <ListSection
            renderIndex={index}
            templates={templates}
            department={department}
            key={`${department.id}-${index}`}
            isActiveStatusSetting={isActiveStatusSetting}
            actions={{
              onEditTemplate: handleEditTemplate,
              onRedirectToCloseReasons: handleRedirectToCloseReasonConfigurationPage,
              onSetActiveStatus: templateId => handleSetActiveStatus(templateId, department.id),
            }}
          />
        ))}
      </Stack>
    </CardContainer>
  );
};
